bq.dashboard = function(element, options) {
  this.options = options;
  this.$element = element;
};

bq.dashboard.DEFAULTS = {
  inputContainer: '.ap-dashboard__input-container',
  dashboardElem: '.ap-dashboard__grid-elem',
  searchElem: '.ap-dashboard__search',
  formElement: '.ap-dashboard__input-wrap',
  // bubble: '.ap-dashboard__bubble',
  inlineInputContainer: '.ap-dashboard__input-wrap_inline',
  searchIcon: '.ap-dashboard__search-icon i'
};

bq.dashboard.prototype = {
  init: function() {
    $('button, ' + this.options.searchIcon + '', [this.options.dashboardElem, this.options.searchElem].join(',')).on('click', {thiz: this}, this.catchEvent);
    $('input[type=text]', [this.options.dashboardElem, this.options.searchElem].join(',')).on('keydown', {thiz: this}, this.catchEvent);
    // $('input[type=text]', this.options.inlineInputContainer).on('keyup', {thiz: this}, this.delay(this.catchEventKeyUp, 1000));
  },

  _ajaxRequest: function(url, data, elem) {
    var parent = elem.closest(this.options.dashboardElem),
        $form = elem.closest(this.options.formElement);

    $('input, button', parent).blur().attr('readonly', true);

    $.ajax({
      url: url,
      data: data,
      success: function (response) {
        var json = JSON.parse(response);

        if (json.redirect) {
          window.location.href = json.redirect;
        }

        if (json.params) {
          $.each(json.params, function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
          });
        }

        var $input = elem;
        if (!elem.is('input')) {
          $input = $form.find('input');
        }

        if (json.error) {
          $('input, button', parent).removeAttr('readonly');

          if (json.message) {
            bq.global.parsley.fieldAddForcedError($input, json.message);
          }
        } else {
          bq.global.parsley.fieldRemoveForcedError($input);

          //updating the bubble with returned counter

          // this.updateBubble(elem, json.count);
        }
      }.bind(this)
    });
  },

  catchEventKeyUp: function(e) {
    var elem = $(e.target),
      $this = e.data.thiz,
      $form = elem.closest($this.options.formElement);

      $form.parsley().validate();

    if ($form.parsley().isValid()) {
      $this._ajaxRequest($form.data('ajax-action'), $form.serialize(), elem);
    }
  },

  catchEvent: function(e) {
    var elem = $(e.target),
      $this = e.data.thiz,
      $form = elem.closest($this.options.formElement);

      if (e.type === 'click' && (elem.closest('button').length > 0 || elem.closest($this.options.searchIcon).length > 0) ||
         (e.type === 'keydown' && (e.keyCode === 13 || e.which === 13)))
      {
        e.preventDefault();

        $form.parsley().validate();

        if ($form.parsley().isValid()) {
          $this._ajaxRequest($form.attr('action'), $form.serialize(), elem);
        }
      }
  },

  updateBubble: function(elem, count) {
    var dashboardElem = elem.closest(this.options.dashboardElem);

    // if ($(this.options.bubble, dashboardElem).length > 0) {
    //   var bubble = $(this.options.bubble, dashboardElem);
    //
    //   if ($('.back', bubble).length > 0 && !bubble.hasClass('flipped')) {
    //     $('.back', bubble).text(count);
    //     bubble.addClass('flipped');
    //
    //   } else {
    //     $('.front', bubble).text(count);
    //     bubble.removeClass('flipped');
    //   }
    // }
  },

  delay: function(callback, ms) {
    var timer = 0;

    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }
};

var dashboardold = $.fn.dashboard;

$.fn.dashboard = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.dashboard');
    var options = $.extend({}, bq.dashboard.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) {
      $this.data('bq.dashboard', (data = new bq.dashboard(this, options)));
    }
    data.init();
  });
};

$.fn.dashboard.Constructor = bq.dashboard;

$.fn.dashboard.noConflict = function () {
  $.fn.dashboard = dashboardold;
  return this;
};

bq.dashboardInit = function() {
  $('.widget-ap-dashboard').each(function () {
    var el = $(this);
    if (el.data('bq.dashboard')) {
      return;
    }
    el.dashboard(el.data());
  });
};

bq.init.push(bq.dashboardInit);